<template>
  <v-card :class="cardClass" class="h-100">
    <v-card-title class="mb-5 primary white--text">
      Basic Infromation
    </v-card-title>
    <v-card-text class="pb-0">
      <v-form ref="basicUpdate">
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="First Name"
              prepend-icon="mdi-account"
              type="text"
              :rules="fieldRules"
              v-model="firstName"
              required
            />
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Last Name"
              prepend-icon="mdi-account"
              type="text"
              :rules="fieldRules"
              v-model="lastName"
              required
            />
          </v-col>
        </v-row>
        <v-dialog
          ref="birthDateDialog"
          v-model="birthDateDialogModal"
          :return-value.sync="birthDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="birthDate"
              label="Birthday"
              prepend-icon="mdi-cake"
              readonly
              v-bind="attrs"
              v-on="on"
              required
              :rules="fieldRules"
            />
          </template>
          <v-date-picker
            v-model="birthDate"
            type="date"
            scrollable
            max="2004-12-31"
          >
            <v-btn small color="primary" @click="birthDateDialogModal = false">
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="primary"
              @click="$refs.birthDateDialog.save(birthDate)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-text-field
          label="Email"
          prepend-icon="mdi-email"
          type="email"
          :rules="emailRules"
          v-model="email"
          required
          disabled
        />
        <v-text-field
          label="Phone"
          prepend-icon="mdi-phone"
          type="tel"
          :rules="fieldRules"
          v-model="phone"
          required
        />
      </v-form>
    </v-card-text>
    <v-card-actions class="px-5 pb-5">
      <v-spacer />
      <v-btn @click="submit" color="primary" depressed>Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import validationRules from '@/validation-rules'

export default {
  props: {
    cardClass: {
      type: String,
      default: ''
    },
    runAlert: Function
  },
  computed: mapGetters(['user', 'userObj']),
  data () {
    return {
      birthDateDialogModal: false,
      firstName: '',
      lastName: '',
      birthDate: '',
      email: '',
      phone: '',
      ...validationRules
    }
  },
  methods: {
    ...mapActions(['updateUser', 'toggleDialog', 'getUser']),
    async submit () {
      if (this.$refs.basicUpdate.validate()) {
        await this.updateUser({
          firstName: this.firstName,
          lastName: this.lastName,
          dob: new Date(this.birthDate),
          phone: this.phone
        })
        if (this.user) {
          console.log('Here')
          this.toggleDialog({
            status: true,
            title: 'Success',
            message: 'Basic information updated successfully'
          })
        }
      }
    }
  },
  async created () {
    await this.getUser()
    this.firstName = this.user.get('firstName')
    this.lastName = this.user.get('lastName')
    this.birthDate = this.user.get('dob')
      ? new Date(this.user.get('dob')).toISOString().substr(0, 10)
      : ''
    this.email = this.user.get('customEmail')
    this.phone = this.user.get('phone')
  }
}
</script>
